import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Link from '../../links/Link';
import theme from '../../theme';

const MenuItem = styled.li`
  list-style: none;
  margin-bottom: $unit / 2;
  padding: 0;

  &:last-child {
    margin-bottom: 0;
  }

  ${({ active }) => active && `
    > * {
      margin: 0 -${theme.unit}px;
      padding: 0 ${theme.unit}px;
      background: ${theme.colors.gray18} !important;
      border-radius: ${theme.unit / 2}px;
    }
  `}
`;

const DropDownItem = option => (
  <MenuItem
    {...option.active && { active: option.active }}
    {...option.onClick && { onClick: option.onClick }}
  >
    {!option.to && (
      <div>{option.value}</div>
    )}
    {option.to && (
      <Link to={option.to}>{option.value}</Link>
    )}
  </MenuItem>
);

DropDownItem.propTypes = {
  _id: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  onClick: PropTypes.func,
  to: PropTypes.string,
};

DropDownItem.defaultProps = {
  _id: null,
  value: null,
  onClick: null,
  to: null,
};

export default DropDownItem;



// WEBPACK FOOTER //
// ./src/components/stateful/DropDown/DropDownItem.js